import React, { useMemo } from "react";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import { useSelector } from "react-redux";
import Loader from "../../components/Loader";
import {
  convertSymbolCodes,
  extractDate,
  extractDateFromStr,
  getLatestUpdatedObject,
} from "../../Utils/utils";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import { useTableResponsive } from "../../hooks/useTableResponsive";
import PdfZipItem from "../../components/PdfZipItem";
import { useLocation } from "react-router-dom";
import useSeo from "../../hooks/useSeo";

const ResearchAndDevelopment = () => {
  const { getText } = useLanguageTranslation();
  const { languageType } = useSelector((state) => state.homeSlice);
  const { data: rndData = [], isLoading: rndIsLoading } =
    useGetProtectedApiDataQuery({ url: "r_and_d", lang: languageType });
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });
  console.log(innerBannerImage);

  useTableResponsive(rndData);

  const lastUpdatedOn = useMemo(() => {
    return extractDateFromStr(getLatestUpdatedObject(rndData)?.changed);
  }, [rndData]);

  if (rndIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        titleLink="/screen-reader"
        levelTwo={false}
        levelThree={false}
        bannerImage={innerBannerImage}
        title={convertSymbolCodes(innerBannerTitle)}
        isActive={convertSymbolCodes(innerBannerTitle)}
      />
      <div className="inner-container">
        <div className="container">
          <div className="container about_inntxt">
            <div className="row">
              <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
              <div className="container">
                <div className="view-content">
                  <div className="research">
                    <div className="d-flex justify-content-between title-sec">
                      <h2>
                        {getText(
                          "Corporate Research & Development Policy",
                          "कॉर्पोरेट अनुसंधान एवं विकास नीति"
                        )}
                      </h2>
                    </div>
                    <div className="table-responsive ">
                      <table className="table table-striped custom-table">
                        <thead className="thead-dark">
                          <tr>
                            <th style={{ width: "56px" }}>
                              {getText("S.No.", "क्र. सं.")}
                            </th>
                            <th>{getText("Details", "विवरण")}</th>
                            <th>{getText("Download", "डाउनलोड")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {rndData.map((item, index) => (
                            <tr key={index}>
                              <td data-key={getText("S.No.", "क्र. सं.")}>
                                {index + 1}
                              </td>
                              <td data-key={getText("Details", "विवरण")}>
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: item.title,
                                  }}
                                ></p>
                              </td>
                              <td data-key={getText("Download", "डाउनलोड")}>
                                <PdfZipItem
                                  filePath={item?.field_r_and_d_file}
                                  filesize={item?.filesize}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResearchAndDevelopment;
